<template>
  <div 
    class="gallery" 
  >
    <v-row class="justify-space-between align-center pa-4 pb-0" no-gutters>
      <h3 class="d-flex align-center">{{ title }}</h3>
      <router-link 
        class="text-hover-underline body-2" 
        :to="to"
        v-if="to"
      >
        查看更多
      </router-link>
    </v-row>
    <div class="gallery-container">
      <div class="d-flex">
        <div v-for="(item, i) in items" :key="i">

          <template v-if="type == 'seller' || type == 'onlineSeller'">
            <div class="seller" @click="$router.push(`/seller/${item.id}`)">
              <v-avatar size="100%" min-height="100">
                <v-img aspect-ratio="1" :src="$HOST_URL + item.usericon"/>
                <span class="status online"></span>
              </v-avatar>
              <div class="text-ellipsis text-center mt-1" :title="item.nickname">{{ item.nickname }}</div>
            </div>
          </template>

          <template v-else-if="['story', 'photo'].includes(item.latest_product.product_type)">
            <v-card 
              dark 
              class="story-item" 
              flat 
              @click="$root.$emit('story', item, item.latest_product, item.latest_product.product_type)"
            >
              <span class="free" v-if="item.latest_product.price === 0">Free</span>
              <span class="unlocked" v-else-if="purchaseID.includes(item.latest_product.id)">已解鎖</span>
              <v-img
                :src="$func.productImagePreview(item.latest_product)"
                gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.4)"
                :width="['story', 'photo'].includes(type) ? '120px' : '155px'"
                aspect-ratio="0.75"
              >
                <v-avatar size="35" :title="item.nickname" @click.stop="$router.push(`/seller/${item.id}`)">
                  <v-img :src="$HOST_URL + item.usericon"/>
                </v-avatar>
                <div class="description" :title="item.latest_product.title">{{ item.latest_product.title }}</div>
              </v-img>
            </v-card>
          </template>

          <template v-else>
            <v-card 
              class="product-item" 
              :to="`/product/${item.latest_product.id}`"
              flat
              @mouseover="item.latest_product.product_type == 'video' ? $func.startPlayVideo($refs, i, $HOST_URL + item.latest_product.video_info[0].uuid_path) : ''"
              @mouseleave="item.latest_product.product_type == 'video' ? $func.stopPlayVideo($refs, i) : ''"
            >
              <div class="soldOut" v-if="item.latest_product.sold > 0 && item.latest_product.product_type == 'clothes'">售罄</div>
              <div :class="{sold: item.latest_product.sold > 0 && item.latest_product.product_type == 'clothes'}" style="width: 100%; height: 100%">
                <template v-if="item.latest_product.product_type == 'video'">
                  <span class="free" v-if="item.latest_product.price === 0">Free</span>
                  <span class="unlocked" v-if="purchaseID.includes(item.latest_product.id)">已解鎖</span>
                  <video-player 
                    v-once
                    :ref="`video${i}`"
                    v-touch-event="() => $router.push(`/product/${item.latest_product.id}`)"
                    :playsinline="true" 
                    @canplay="$func.onPlayerCanplay($event, i)"
                    :options="$func.videoOption({
                      src: $HOST_URL + item.latest_product.video_info[0].uuid_path,
                      autoplay: false,
                      muted: true,
                      loop: true,
                      controls: false,
                      poster: $func.productImagePreview(item.latest_product)
                    })"></video-player>
                </template>
                <template v-else>
                  <v-img :src="$func.productImagePreview(item.latest_product)" aspect-ratio="1.75"/>
                </template>
                <div class="information">
                  <v-avatar size="35" class="mr-2" :title="item.nickname" @click.prevent="$router.push(`/seller/${item.id}`)">
                    <v-img :src="$HOST_URL + item.usericon"/>
                  </v-avatar>
                  <v-col class="pa-0 rightInfo">
                    <div class="product-title text-ellipsis" :title="item.latest_product.title">{{ item.latest_product.title }}</div>
                    <div class="d-flex align-center review">
                      <template v-if="!['clothes'].includes(item.latest_product.product_type)">
                        <v-icon>fa-thumbs-up</v-icon>
                        <span>{{ mul(item.latest_product.praise_rate, 100) }}%</span>
                      </template>
                      <template v-if="['video'].includes(item.latest_product.product_type)">
                        <v-icon>fa-unlock</v-icon>
                        <span>{{ item.latest_product.unlocks }}</span>
                      </template>
                      <template v-if="['clothes'].includes(item.latest_product.product_type)">
                        <v-icon>fa-eye</v-icon>
                        <span>{{ item.latest_product.views }}</span>
                      </template>
                    </div>
                  </v-col>
                </div>
              </div>
            </v-card>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['title', 'type', 'items', 'to'],
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters('user', ['purchaseID'])
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  background-color: $grey-3;
  margin-bottom: 16px;
  .gallery-container {
    padding: 16px 16px 8px 16px;
    overflow-x: scroll;
    .seller {
      @extend .pointer;
      font-size: 14px;
      width: 100px;
      height: auto;
      margin-right: 16px;
      @include mobile {
        width: 80px;
      }
      &:hover {
        transform: scale(1.015);
      }
      .status {
        //@extend .green;
        position: absolute;
        z-index: 100;
        right: 0;
        bottom: 0;
        width: 40px;
        height: 40px;
        border-radius: 20px;
      }
    }
    .story-item {
      margin-right: 8px;
    }
    .product-item {
      width: 250px;
      margin-right: 8px;
    }
  }
}
</style>